import type { StatutArticle } from '@troc/shared'
import { LIBELLE_STATUT } from '@troc/shared'

/** Pastille de statut d'article — les couleurs viennent des classes du thème. */
export function PastilleStatut({ statut }: { statut: StatutArticle }) {
  return <span className={`pastille pastille-${statut}`}>{LIBELLE_STATUT[statut]}</span>
}

const LIBELLE_CONTRAT = { actif: 'Actif', echu: 'Échu', solde: 'Soldé' } as const

export function PastilleContrat({ statut }: { statut: 'actif' | 'echu' | 'solde' }) {
  return <span className={`pastille pastille-${statut}`}>{LIBELLE_CONTRAT[statut]}</span>
}

export function PastilleReversement({ mode }: { mode: 'especes' | 'virement' }) {
  return (
    <span className={`pastille pastille-${mode}`}>{mode === 'virement' ? 'Virement' : 'Espèces'}</span>
  )
}
